export default __webpack_public_path__ + "static/B0259-97365d8b2016fcb956ddb9d8bd281271.png";